/* Geschenke-Shop – Warenkorb: Pflicht-Zustimmung vor der Kasse (§ 356 Abs. 6 BGB).
   Ohne Haken sind „Zur Kasse" und Express-Zahlung gesperrt. Die Zustimmung wird mit
   Zeitpunkt als Warenkorb-Attribut gespeichert und erscheint so an der Bestellung. */

(() => {
  const ATTR = 'Zustimmung digitale Inhalte';
  const ATTR_TIME = 'Zustimmung Zeitpunkt (Warenkorb)';

  function sync(root) {
    const extras = root.querySelector('gs-cart-extras');
    const container = extras?.closest('.cart-summary, .cart-drawer__summary, form, .cart-page') || document;
    const ctas = container.querySelector('.cart__ctas') || document.querySelector('.cart__ctas');
    if (!extras || !ctas) return;
    const needs = extras.dataset.needsConsent === 'true';
    const box = extras.querySelector('[data-gs-cart-consent]');
    const ok = !needs || Boolean(box?.checked);
    const checkout = ctas.querySelector('.cart__checkout-button');
    if (checkout) checkout.disabled = !ok || checkout.hasAttribute('data-cart-empty');
    ctas.classList.toggle('gs-ctas-locked', !ok);
    const hint = extras.querySelector('[data-gs-cart-consent-hint]');
    if (hint) hint.hidden = ok;
  }

  async function save(box) {
    const attributes = box.checked
      ? { [ATTR]: box.value, [ATTR_TIME]: new Date().toISOString() }
      : { [ATTR]: '', [ATTR_TIME]: '' };
    try {
      await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes }),
      });
    } catch {
      /* Netzfehler: Haken bleibt, beim nächsten Klick wird erneut gespeichert */
    }
  }

  document.addEventListener('change', (event) => {
    const box = event.target;
    if (!(box instanceof HTMLInputElement) || !box.matches('[data-gs-cart-consent]')) return;
    sync(document);
    save(box);
  });

  let frame = 0;
  const observer = new MutationObserver(() => {
    if (frame) return;
    frame = window.requestAnimationFrame(() => {
      frame = 0;
      sync(document);
    });
  });
  const start = () => {
    sync(document);
    observer.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
